import React from 'react';
import { Container, Button, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import aboutImage from '../images/about.png';

const AboutSection: React.FC = () => {
  return (
    <section className="about-section">
      <Container>
        <h2 className="about-title fade-in">Who We Are</h2>
        <Row className="align-items-center">
          <Col md={6} className="mb-4">
            <div className="image-wrapper fade-in">
              <img
                src={aboutImage}
                alt="Who We Are"
                className="img-fluid"
              />
            </div>
          </Col>
          <Col md={6}>
            <p className="about-text fade-in">
              We are a non-profit organization dedicated to empowering youth in India through holistic education. Our initiatives include schools, colleges, arts academies, certification programs, and training centres. We focus on career development, healthcare, IT literacy, and environmental sustainability.
            </p>
            <div className="text-center mt-4">
            
              <Link to="/become-member/">
                     <Button variant="primary" className="join-btn fade-in">
                     Join Our Mission
                     </Button>
                   </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutSection;
